module.exports = __webpack_public_path__ + "static/img/9.4f2b277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/9.png
// module id = 29Rc
// module chunks = 0